"use client";
import { useQuery } from "@tanstack/react-query";

const generateRandomViewerCount = () => {
  return Math.floor(Math.random() * 11) + 10;
};

const useViewerCount = (carId: string) => {
  return useQuery({
    queryKey: ["viewerCount", carId],
    queryFn: generateRandomViewerCount,
    refetchInterval: 50000,
    refetchOnWindowFocus: true,
  });
};

export default useViewerCount;
